import { render, staticRenderFns } from "./DetailImages.vue?vue&type=template&id=4d5bc422&scoped=true&"
import script from "./DetailImages.vue?vue&type=script&lang=js&"
export * from "./DetailImages.vue?vue&type=script&lang=js&"
import style0 from "./DetailImages.vue?vue&type=style&index=0&id=4d5bc422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5bc422",
  null
  
)

export default component.exports